import { render, staticRenderFns } from "./MediaViewModal.vue?vue&type=template&id=bb95a736&scoped=true"
import script from "./MediaViewModal.vue?vue&type=script&lang=js"
export * from "./MediaViewModal.vue?vue&type=script&lang=js"
import style0 from "./MediaViewModal.vue?vue&type=style&index=0&id=bb95a736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb95a736",
  null
  
)

export default component.exports